/**
 * Become a Member page configuration
 */
const becomeMemberConfig = {
  slug: 'become-a-member',
  category: 'Membership',
  title: 'Join Uhamiaji SACCOS Today',
  breadcrumb: 'Become a Member',
  introduction:
    'Becoming a member of Uhamiaji SACCOS gives you access to a wide range of financial products and services designed to improve your financial well-being. As a member, you can save regularly, apply for affordable loans, purchase shares, participate in Annual General Meetings, receive dividends, and enjoy other exclusive member benefits. Follow the simple steps below to begin your membership journey.',
  heroIcon: 'UserPlus',
  heroCompact: true,
  heroShowIcon: false,
  heroShowActions: false,
  primaryAction: null,
  secondaryAction: {
    label: 'Contact Uhamiaji SACCOS',
    link: '/contact',
    icon: 'Phone',
  },
  meta: {
    title: 'Uhamiaji SACCOS | Become a Member',
    description:
      'Join Uhamiaji SACCOS today and access savings, loans, shares, and exclusive member benefits.',
  },
  sections: [
    {
      type: 'journey',
      title: 'Membership Journey',
      items: [
        {
          number: '01',
          icon: 'FileEdit',
          title: 'Apply for Membership',
          description:
            'Submit your membership application with the required personal, employment, contact information, and supporting documents.',
        },
        {
          number: '02',
          icon: 'FileSearch',
          title: 'Application Review',
          description:
            'Your application is reviewed and verified against the Uhamiaji SACCOS membership eligibility requirements.',
        },
        {
          number: '03',
          icon: 'CheckCircle',
          title: 'Approval',
          description:
            'Once your application meets the requirements, the membership application proceeds to the approval stage.',
        },
        {
          number: '04',
          icon: 'Banknote',
          title: 'Payment & Membership',
          description:
            'Pay the applicable membership fee and purchase the required minimum shares according to the Membership Policy.',
        },
        {
          number: '05',
          icon: 'Unlock',
          title: 'Activation',
          description:
            'After payment confirmation and completion of the requirements, your Uhamiaji SACCOS membership is activated.',
        },
        {
          number: '06',
          icon: 'Sparkles',
          title: 'Enjoy Uhamiaji SACCOS Services',
          description:
            'Access savings, shares, statements, member services and other available financial services.',
        },
      ],
    },
    {
      type: 'steps',
      title: 'Detailed Membership Steps',
      items: [
        {
          number: '01',
          icon: 'FileEdit',
          heading: 'Submit Your Membership Application',
          content:
            'Complete the application form by providing your personal, employment, and contact information together with any required supporting documents including salary slip and passport size photo. Ensure that all information provided is accurate, as it will be used during the verification process.',
        },
        {
          number: '02',
          icon: 'FileSearch',
          heading: 'Application Review',
          content:
            'Once your application has been submitted, the Uhamiaji SACCOS Office will review and verify the information provided to determine whether you meet the membership eligibility requirements. If additional information is required, you will be contacted before the review process is completed.',
        },
        {
          number: '03',
          icon: 'Banknote',
          heading: 'Pay Membership Fees and Purchase Shares',
          content:
            'Following approval, you will be required to pay the applicable membership fee and purchase the minimum required shares as stipulated by the Uhamiaji SACCOS Membership Policy.\n\nMembers may choose to pay the membership fee and required shares in full as a one-time payment or authorize monthly deductions from their salary until the required amount has been fully paid.\n\nOnce the membership fee and minimum shares have been completed and your membership has been activated, you will be eligible to start making regular savings contributions and access other Uhamiaji SACCOS products and services.\n\nPayment confirmation is required before your membership can be activated.',
        },
        {
          number: '04',
          icon: 'Sparkles',
          heading: 'Enjoy Uhamiaji SACCOS Services',
          content:
            'Once your account is activated, you can immediately begin managing your savings, monitoring your shares, viewing account statements, participating in member meetings, receiving notifications, and accessing other member services offered by Uhamiaji SACCOS.\n\nHowever, members shall become eligible to access financial products and services, including loan facilities, only after completing a minimum membership period of three (3) months and fulfilling all other eligibility requirements in accordance with the Uhamiaji SACCOS Membership Policy.',
        },
      ],
    },
    {
      type: 'callout',
      title: 'Ready to become a member?',
      content:
        'Start your membership journey today and enjoy the benefits of being part of Uhamiaji SACCOS.',
      variant: 'light',
      primaryAction: {
        label: 'Apply for Membership',
        link: 'https://wallet.uhamiajisaccos.or.tz/',
        icon: 'UserPlus',
      },
      secondaryAction: {
        label: 'Contact Us',
        link: '/contact',
        icon: 'Phone',
      },
    },
  ],
  support: { enabled: false },
};

export default becomeMemberConfig;
